/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { activities_ActivityResponse } from '../models/activities_ActivityResponse';
import type { activities_BatchCreateRequest } from '../models/activities_BatchCreateRequest';
import type { activities_BatchCreateResponse } from '../models/activities_BatchCreateResponse';
import type { activities_ChildCurrentStateResponse } from '../models/activities_ChildCurrentStateResponse';
import type { activities_ChildrenCurrentStatesRequest } from '../models/activities_ChildrenCurrentStatesRequest';
import type { activities_ChildrenCurrentStatesResponse } from '../models/activities_ChildrenCurrentStatesResponse';
import type { activities_CreateActivityDTO } from '../models/activities_CreateActivityDTO';
import type { activities_GroupActivitiesRequest } from '../models/activities_GroupActivitiesRequest';
import type { activities_GroupActivitiesResponse } from '../models/activities_GroupActivitiesResponse';
import type { activities_ListActivitiesResponse } from '../models/activities_ListActivitiesResponse';
import type { activities_UpdateActivityRequest } from '../models/activities_UpdateActivityRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ActivitiesService {
    /**
     * List activities with filters
     * Get paginated list of activities with optional filters. Parent callers receive the check-out payload with pickup_exception_reason and pickup_contact_id removed.
     * @param page Page number
     * @param pageSize Items per page
     * @param childId Filter by child ID
     * @param type Filter by activity type
     * @param dateFrom Filter from date (RFC3339 format)
     * @param dateTo Filter to date (RFC3339 format)
     * @param groupId Filter by group ID (children with an allocation active as of today in this group)
     * @param childcareId Filter by childcare ID (children with an allocation active as of today in a group of this childcare)
     * @returns activities_ListActivitiesResponse OK
     * @throws ApiError
     */
    public static getApiV1Activities(
        page: number = 1,
        pageSize: number = 20,
        childId?: string,
        type?: 'check_in' | 'check_out' | 'toilet_pee' | 'toilet_poo' | 'toilet_nothing' | 'feeding_milk' | 'feeding_porridge' | 'feeding_solid' | 'feeding_snack' | 'feeding_breastmilk' | 'feeding_refused' | 'nap_start' | 'nap_end' | 'health_accident' | 'health_illness' | 'health_medication' | 'picture' | 'note' | 'mood_check',
        dateFrom?: string,
        dateTo?: string,
        groupId?: string,
        childcareId?: string,
    ): CancelablePromise<activities_ListActivitiesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/activities',
            query: {
                'page': page,
                'page_size': pageSize,
                'child_id': childId,
                'type': type,
                'date_from': dateFrom,
                'date_to': dateTo,
                'group_id': groupId,
                'childcare_id': childcareId,
            },
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list activities`,
            },
        });
    }
    /**
     * Create single activity
     * Create a single activity (for web admin use)
     * @param request Activity to create
     * @returns activities_ActivityResponse Created
     * @throws ApiError
     */
    public static postApiV1Activities(
        request: activities_CreateActivityDTO,
    ): CancelablePromise<activities_ActivityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/activities',
            body: request,
            errors: {
                400: `Validation errors, invalid request format, or activity_time outside the accepted window`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Child not found`,
                500: `Failed to create activity`,
            },
        });
    }
    /**
     * Delete activity
     * Soft delete an activity
     * @param id Activity ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Activities(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/activities/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing activity id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Activity not found`,
                500: `Failed to delete activity`,
            },
        });
    }
    /**
     * Get activity by ID
     * Get a single activity by ID. Parent callers receive the check-out payload with pickup_exception_reason and pickup_contact_id removed.
     * @param id Activity ID
     * @returns activities_ActivityResponse OK
     * @throws ApiError
     */
    public static getApiV1Activities1(
        id: string,
    ): CancelablePromise<activities_ActivityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/activities/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing activity id`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Activity not found`,
                500: `Failed to get activity`,
            },
        });
    }
    /**
     * Update activity
     * Update an existing activity
     * @param id Activity ID
     * @param request Updated activity data
     * @returns activities_ActivityResponse OK
     * @throws ApiError
     */
    public static putApiV1Activities(
        id: string,
        request: activities_UpdateActivityRequest,
    ): CancelablePromise<activities_ActivityResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/activities/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid or missing activity id, validation errors, invalid type transition (only within-category changes allowed for toilet/feeding types), or activity_time outside the accepted window`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Activity not found`,
                500: `Failed to update activity`,
            },
        });
    }
    /**
     * Batch create activities (mobile sync)
     * Create multiple activities in a single request (used by mobile apps for offline sync). Supports idempotency via the Idempotency-Key header. If the same key is reused with a different payload, returns 409 Conflict. The server persists idempotency keys. Activity IDs can be provided in the request or will be generated by the server if omitted.
     * @param request Activities to create
     * @param idempotencyKey Optional idempotency key for preventing duplicate requests. The server will persist this key and return 409 Conflict if the same key is reused with a different payload.
     * @param xOfflineQueuedAt RFC3339 enqueue time of the oldest queued command; set by the mobile offline-sync path. Required after the pickup-collector rollout for a queued check-out that records no collector.
     * @returns activities_BatchCreateResponse Activities created successfully
     * @throws ApiError
     */
    public static postApiV1ActivitiesBatch(
        request: activities_BatchCreateRequest,
        idempotencyKey?: string,
        xOfflineQueuedAt?: string,
    ): CancelablePromise<activities_BatchCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/activities/batch',
            headers: {
                'Idempotency-Key': idempotencyKey,
                'X-Offline-Queued-At': xOfflineQueuedAt,
            },
            body: request,
            errors: {
                400: `Validation error: invalid activity type, payload validation failed, child not found, activity_time outside the accepted window, or malformed X-Offline-Queued-At header`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                409: `Idempotency key reused with different payload`,
                429: `Rate limit exceeded`,
                500: `Internal server error (database failure)`,
            },
        });
    }
    /**
     * Get group activity overview
     * Get activities for multiple children filtered to overview-relevant types (feeding, sleep, events, photos)
     * @param request Child IDs and date
     * @returns activities_GroupActivitiesResponse OK
     * @throws ApiError
     */
    public static postApiV1ActivitiesGroupOverview(
        request: activities_GroupActivitiesRequest,
    ): CancelablePromise<activities_GroupActivitiesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/activities/group-overview',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to get group activities`,
            },
        });
    }
    /**
     * Get child current state
     * Get current state for a child (check-in status, last feeding, etc.). Optionally accepts a date query parameter to calculate state for a specific date (YYYY-MM-DD format). Defaults to today if not provided.
     * @param id Child ID
     * @param date Date to calculate state for (YYYY-MM-DD format)
     * @returns activities_ChildCurrentStateResponse OK
     * @throws ApiError
     */
    public static getApiV1ChildrenCurrentState(
        id: string,
        date?: string,
    ): CancelablePromise<activities_ChildCurrentStateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/children/{id}/current-state',
            path: {
                'id': id,
            },
            query: {
                'date': date,
            },
            errors: {
                400: `Invalid date format`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Child state not found`,
                500: `Failed to get child state`,
            },
        });
    }
    /**
     * Get current state for multiple children
     * Get current state (check-in status, nap status, etc.) for multiple children by their IDs. Used by mobile attendance screen to display check-in status indicators. Optionally accepts a date parameter to calculate state for a specific date (YYYY-MM-DD format). Defaults to today if not provided.
     * @param request Child IDs to fetch state for (with optional date)
     * @returns activities_ChildrenCurrentStatesResponse OK
     * @throws ApiError
     */
    public static postApiV1ChildrenCurrentStates(
        request: activities_ChildrenCurrentStatesRequest,
    ): CancelablePromise<activities_ChildrenCurrentStatesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/children/current-states',
            body: request,
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Organization ID not found in token or parent access denied`,
                500: `Failed to get children states`,
            },
        });
    }
}
